var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolumeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.99999L14.4233 7.11294C15.0857 6.64536 16 7.11909 16 7.92991V15.9289C16 16.7657 15.0335 17.2324 14.3781 16.712L12.2222 15H9C8.44772 15 8 14.5523 8 14V9.99999C8 9.4477 8.44772 8.99999 9 8.99999H11.75Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeOff);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjc1IDguOTk5OTlMMTQuNDIzMyA3LjExMjk0QzE1LjA4NTcgNi42NDUzNiAxNiA3LjExOTA5IDE2IDcuOTI5OTFWMTUuOTI4OUMxNiAxNi43NjU3IDE1LjAzMzUgMTcuMjMyNCAxNC4zNzgxIDE2LjcxMkwxMi4yMjIyIDE1SDlDOC40NDc3MiAxNSA4IDE0LjU1MjMgOCAxNFY5Ljk5OTk5QzggOS40NDc3IDguNDQ3NzIgOC45OTk5OSA5IDguOTk5OTlIMTEuNzVaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };